'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

var _classesForEvent = require('../../../common/utils/classes-for-event');

var _accounts = require('ifeis-isomorphic/lib/redux/actions/accounts');

var _registrations = require('ifeis-isomorphic/lib/redux/actions/registrations');

var _stages = require('ifeis-isomorphic/lib/redux/actions/stages');

var _setSelectedFeis = require('ifeis-isomorphic/lib/redux/actions/feiseanna/setSelectedFeis');

var _setSelectedFeis2 = _interopRequireDefault(_setSelectedFeis);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * FeisDayController directive
 *
 * Public attributes:
 *
 * feiseanna     - to pass a list of active feiseanna details from parent scope
 * user          - to pass user details TODO we should get it from Redux in the future
 *
 */

var FeisDayController = function () {
  function FeisDayController($state, $ngRedux, fEventParticipantsModal, $scope, fPrintCompCards) {
    var _this = this;

    _classCallCheck(this, FeisDayController);

    this._ = { $state: $state, fEventParticipantsModal: fEventParticipantsModal, $ngRedux: $ngRedux, $scope: $scope, fPrintCompCards: fPrintCompCards };
    this.classesForEvent = _classesForEvent.classesForEvent;
    $ngRedux.connect((0, _mapStateToController2.default)(this.user.id, this.feiseanna))(this);

    this._.$ngRedux.dispatch({ type: '/SOCKET_JOIN_ROOM', data: { room: 'FEISEANNA::' + this.feiseanna.id, feisId: this.feiseanna.id } });
    this._.$ngRedux.dispatch({ type: '/SOCKET_JOIN_ROOM', data: { room: 'EVENTS::' + this.feiseanna.id, feisId: this.feiseanna.id } });
    this._.$ngRedux.dispatch({ type: '/SOCKET_JOIN_ROOM', data: { room: 'SCHEDULE::' + this.feiseanna.id, feisId: this.feiseanna.id } });

    $scope.$on('$destroy', function () {
      // clean up just in case user doesn't collapse the selected feis section for feis day.
      $ngRedux.dispatch((0, _setSelectedFeis2.default)(undefined));
      _this._.$scope.$on('$destroy', function () {
        return _this._.$ngRedux.dispatch({ type: '/SOCKET_LEAVE_ROOM', data: { room: 'FEISEANNA::' + _this.feiseanna.id, feisId: _this.feiseanna.id } });
      });
      _this._.$scope.$on('$destroy', function () {
        return _this._.$ngRedux.dispatch({ type: '/SOCKET_LEAVE_ROOM', data: { room: 'EVENTS::' + _this.feiseanna.id, feisId: _this.feiseanna.id } });
      });
      _this._.$scope.$on('$destroy', function () {
        return _this._.$ngRedux.dispatch({ type: '/SOCKET_LEAVE_ROOM', data: { room: 'SCHEDULE::' + _this.feiseanna.id, feisId: _this.feiseanna.id } });
      });
    });
  }

  _createClass(FeisDayController, [{
    key: 'go',
    value: function go(state, params) {
      this._.$state.go(state, params);
    }
  }, {
    key: 'selectFeis',
    value: function selectFeis(feis) {
      var _this2 = this;

      if (!this.selectedFeis || this.selectedFeis.feis.id !== feis.feis.id) {
        this._.$ngRedux.dispatch((0, _setSelectedFeis2.default)(feis.feis.id));
        this._.$ngRedux.dispatch((0, _stages.getStages)(feis.feis.id));
        this._.$ngRedux.dispatch((0, _accounts.getMyCompetitorsForFeis)(feis.feis.id, this.user.id)).then(function (deps) {
          return deps.payload.map(function (d) {
            return _this2._.$ngRedux.dispatch((0, _registrations.getRegistrations)(feis.feis.id, d.id));
          });
        });
      } else {
        this._.$ngRedux.dispatch((0, _setSelectedFeis2.default)(undefined));
      }
    }
  }, {
    key: 'openFeisParticipantsModal',
    value: function openFeisParticipantsModal(e, event) {
      this._.fEventParticipantsModal(e, this.selectedFeis.feis, event);
    }
  }, {
    key: 'getStageForEvent',
    value: function getStageForEvent(event) {
      var scheduledOnStage = this.selectedFeis.stages.find(function (s) {
        if (!s.events.get('loading') && s.stage) return s.events.find(function (e) {
          return e.get('id') === event.id;
        });
      });
      return scheduledOnStage ? scheduledOnStage.stage.get('name') : '-';
    }
  }, {
    key: 'prepareStatus',
    value: function prepareStatus(status, event) {
      switch (true) {
        case status === 'ADJ':
          return 'Adjudication';
        case status === 'CI':
          return 'Check In';
        case status === 'TABS':
          return 'Tabulation';
        case status === 'QA':
          return 'QA';
        case status === 'RCL':
          return 'Announce';
        case status === 'RES' && event.commentsReleased !== 1:
          return 'Results, Comments Pending';
        case status === 'RES' && event.commentsReleased === 1:
          return 'Results, Comments Released';
        default:
          return 'Pending';
      }
    }
  }, {
    key: 'prepareStatusMobile',
    value: function prepareStatusMobile(status, event) {
      switch (true) {

        case status === 'ADJ':
          return 'Adj';
        case status === 'CI':
          return 'Check In';
        case status === 'TABS':
          return 'Tab';
        case status === 'QA':
          return 'QA';
        case status === 'RCL':
          return 'Announce';
        case status === 'RES' && event.commentsReleased === 1:
          return 'Results';
        case status === 'RES' && event.commentsReleased !== 1:
          return 'Comments';
        default:
          return 'Pending';
      }
    }
  }, {
    key: 'printCompetitorCards',
    value: function printCompetitorCards(competitor) {
      this._.fPrintCompCards(this.selectedFeis.feis.id, _extends({}, competitor));
    }
  }]);

  return FeisDayController;
}();

exports.default = angular.module('ifeis.dashboard-feis-day', ['ngMaterial', 'ifeis.dashboard-event-modal', 'ifeis.printing.compcards']).directive('fFeisDay', function () {
  return {
    controller: FeisDayController,
    controllerAs: 'fd',
    bindToController: true,
    template: require('./tpl.html'),
    restrict: 'E',
    scope: {
      feiseanna: "=",
      user: "="
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./routes/dashboard/feis-day/index.js
// module id = 521
// module chunks = 0